import React from "react";

export const trophy = () => {
  return (
    <svg
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="m16.829 15.11c-.349 0-.662-.245-.734-.6-.083-.406.179-.802.585-.885 2.731-.556 5.626-3.918 5.882-9.125h-3.312c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.08c.414 0 .75.336.75.75 0 6.499-3.572 10.626-7.1 11.345-.051.01-.101.015-.151.015z"
          fill="currentColor"
        />
      </g>
      <g>
        <path
          d="m7.161 15.09c-.054 0-.109-.006-.165-.018-3.476-.78-6.996-4.919-6.996-11.322 0-.414.336-.75.75-.75h4c.414 0 .75.336.75.75s-.336.75-.75.75h-3.231c.255 5.134 3.111 8.504 5.806 9.108.404.091.658.492.568.896-.079.349-.389.586-.732.586z"
          fill="currentColor"
        />
      </g>
      <g>
        <path
          d="m13.25 16.11c-.414 0-.75.336-.75.75h-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.64c0 .414.336.75.75.75h2.5c.414 0 .75-.336.75-.75v-3.64c0-.414-.336-.75-.75-.75z"
          fill="currentColor"
        />
      </g>
      <g>
        <path
          d="m14.25 20h-4.5c-1.517 0-2.75 1.233-2.75 2.75v.5c0 .414.336.75.75.75h8.5c.414 0 .75-.336.75-.75v-.5c0-1.517-1.233-2.75-2.75-2.75z"
          fill="currentColor"
        />
      </g>
      <g>
        <path
          d="m18.25 0h-12.5c-.965 0-1.75.785-1.75 1.75v7.255c.043 6.456 7.439 9.095 7.754 9.204.08.028.163.042.246.042s.166-.014.245-.041c.316-.11 7.755-2.75 7.755-9.21v-7.25c0-.965-.785-1.75-1.75-1.75z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
